import { useRoutineTeleopModalBridge } from '@sbrc/hooks';

const IPadTeleopModalBridge = (): null => {
  useRoutineTeleopModalBridge();

  return null;
};

export default IPadTeleopModalBridge;
